var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgEdit = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5301 4.12333C12.5301 5.97174 14.0285 7.47018 15.8769 7.47018M5.53311 11.1202L13.3668 3.28659C13.6076 3.04583 13.728 2.92545 13.8435 2.83917C14.5533 2.3091 15.5272 2.30911 16.237 2.8392C16.3525 2.92548 16.4729 3.04586 16.7136 3.28663C16.9544 3.52739 17.0748 3.64778 17.161 3.76331C17.6911 4.47308 17.6911 5.44697 17.161 6.15674C17.0747 6.27226 16.9544 6.39265 16.7136 6.6334L8.87994 14.4671C8.37065 14.9764 8.11599 15.231 7.82586 15.4334C7.56834 15.613 7.29057 15.7616 6.99829 15.8763C6.669 16.0054 6.31586 16.0761 5.6096 16.2173L3.32617 16.674L3.78285 14.3906C3.92411 13.6843 3.99474 13.3312 4.1239 13.0019C4.23854 12.7096 4.3872 12.4318 4.56681 12.1743C4.76915 11.8842 5.02381 11.6295 5.53311 11.1202Z",
    stroke: "#23252F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEdit);
export default ForwardRef;